/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsHorizontal = createReactComponent(
  "arrows-horizontal",
  "IconArrowsHorizontal",
  [
    ["path", { d: "M7 8l-4 4l4 4", key: "svg-0" }],
    ["path", { d: "M17 8l4 4l-4 4", key: "svg-1" }],
    ["path", { d: "M3 12l18 0", key: "svg-2" }]
  ]
);

export { IconArrowsHorizontal as default };
//# sourceMappingURL=IconArrowsHorizontal.js.map
